import { createContext } from 'react';

const DEFAULT_VALUES = {
};

export const ProjectNotesContext = createContext(DEFAULT_VALUES);
